// ==========================================================
// FEATURED POSTS CAROUSEL
// ==========================================================
export default function initFeaturedPostsCarousel() {
    const featuredPostsCarousels = document.querySelectorAll("[data-featured-posts]");

    featuredPostsCarousels.forEach((carousel) => {
        const slides = Array.from(carousel.querySelectorAll("[data-featured-post]"));

        const dots = Array.from(carousel.querySelectorAll("[data-featured-dot]"));

        if (!slides.length) {
            return;
        }

        let activeIndex = 0;

        const render = () => {
            /**
             * Sécurité :
             * activeIndex ne peut jamais dépasser
             * le nombre de slides disponibles.
             */
            if (activeIndex >= slides.length) {
                activeIndex = 0;
            }

            slides.forEach((slide, index) => {
                const isActive = index === activeIndex;

                slide.classList.toggle("is-active", isActive);

                slide.setAttribute("aria-hidden", isActive ? "false" : "true");
            });

            dots.forEach((dot, index) => {
                const isActive = index === activeIndex;

                dot.classList.toggle("is-active", isActive);

                dot.setAttribute("aria-current", isActive ? "true" : "false");
            });
        };

        dots.forEach((dot) => {
            dot.addEventListener("click", () => {
                const index = Number(dot.dataset.index);

                if (Number.isNaN(index) || index < 0 || index >= slides.length) {
                    return;
                }

                activeIndex = index;

                render();
            });
        });

        render();
    });
}
